var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-shifted"},[_c('b-row',_vm._b({},'b-row',_vm.gridColumns,false),_vm._l((_vm.contentSlotKeys),function(sKey){return _c('b-col',{key:sKey},[_vm._t(sKey)],2)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }